import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  tabs: {
    '.ant-tabs-nav': {
      marginBlockStart: token.marginXXS
    },
    '.ant-tabs-tab-btn': {
      display: 'inline-flex',
      alignItems: 'center'
    },
    '.ant-tabs-tab-icon': {
      display: 'inline-flex',
      alignItems: 'center'
    },
    '.ant-tabs-tab-btn .ant-badge': {
      color: 'inherit'
    }
  }
}))
